import { CORE_ROUTE } from "@obg/ngx.core";

export const LOGIN_DIALOG_ID = CORE_ROUTE.auth.login;
